<template>
  <!--调价单-->
  <div class="page-template add-page order-add-page">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button type="primary" plain @click="refresh">刷新</el-button>
      <!--      <el-button type="primary" plain @click="checkGoods">选择商品</el-button>-->
      <el-button type="primary" plain @click="submitAuth" :disabled="buttonShow">保存</el-button>
      <el-button type="primary" plain @click="audit" :disabled="auditShow">审核</el-button>
      <!--      <el-button type="primary" plain @click="priceDownloadTemplate">下载模板</el-button>-->
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm"
                         :formOptions="listFormOptions"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good"
      >选择商品
      </el-button
      >
      <el-button type="primary" plain @click="priceImport">导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="800"
      :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        ref="goodList"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        :searchAuto="searchAuto"
        :otherParam="otherParam"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importFile" @downTemplate="downTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
// 商品列表组件
import goodList from '@/components/business/goodList';
// 导入模版组件
import importTemplate from '@/components/business/importTemplate';
// 添加要货单组件
import listOperationNew from "@/components/template/listOperationNew";
// 要货单搜索组件
import listOperationForm from '@/components/template/listOperationForm';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    listOperationNew,
    goodList,
    listOperationForm,
    importTemplate
  },
  data() {
    return {
      isCheck: false,
      complexShow: true,
      goodsTxt: "",
      importShow: false, // 显示弹窗
      searchAuto: true, // 自动检索
      goodListSelect: false,
      loading: false,
      title: '',
      listShow: false,
      listTableData: [],
      goodList: [],
      auditShow: true,
      buttonShow: false,
      formModel: {},
      dialogShow: false,
      otherParam: {statusList: [10, 20, 30]}, // goodsInfoIncludeSpecs
      selectUrl: {url: api.archives.asGoodsSpecsMap},
      //  添加头部字段
      // 条件
      listFormOptions: {
        // disabled: false,
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          }
        },
        labelWidth: '130px',
        columns:
          [
            {
              label: '业务单号：',
              type: 'input',
              prop: 'orderNo',
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              disabled: true,
              span: 12
            },
            {
              type: 'input',
              prop: 'id',
              hidden: true
            },
            // {
            //   label: '调价级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
            //   change: this.loginTypeChange,
            //   disabled: false,
            //   span: 12,
            // },
            {
              label: '指定门店',
              type: 'select',
              prop: 'seStoreIds',
              data: [],
              multiple: true, // 多选
              collapse: true,
              // hidden:false,
              isHasAll: true,
              span: 12,
              url: api.system.seStore,
              change: this.getSelectParam,
              tips: '至少选择一个调价门店'
            },
            {
              label: '调价门店',
              type: 'select',
              prop: 'storeId',
              data: [],
              hidden: true,
              // defaultValue:this.storeId,
              span: 12,
              url: api.system.seStore,
              change: this.getSelectParam
            },
            {
              label: '备注：',
              type: 'input',
              prop: 'remarks',
              maxLength: 16,
              span: 12
            },
            {
              label: '调价类别：',
              type: 'checkbox',
              prop: 'types',
              span: 24,
              data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.type'),
              change: this.priceTypeChange,
              defaultIndex: [0, 1]

            },
            {
              type: 'input',
              prop: 'type',
              hidden: true
            },
            {
              type: 'input',
              prop: 'voucherDttm',
              hidden: true
            },
            {
              type: 'input',
              prop: 'voucherName',
              hidden: true
            }
          ]
      },
      // 添加表格字段
      listColumns: {
        hideSum: true,
        disabled: false,
        indexShow: true, // 是否显示索引
        columns: [
          {
            label: "操作",
            code: "delete",
            type: "operation",
            width: "80"
          },
          {label: '序号', type: 'index', width: 80, prop: 'idx'},
          {
            label: '条码',
            prop: 'barCode',
            // type: 'input',
            width: '150',
            // keyup: this.getSearchInfo,
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150'

          },
          // {
          //   label: '规格',
          //   prop: 'specs',
          //   width: '70'
          // },
          // {
          //   label: '单位',
          //   prop: 'unitName',
          //   width: '70'
          // },
          {
            label: '原进货价',
            prop: 'buyPrice',
            align: 'center',
            width: '110',
            isShow: true
          },
          {
            label: '进货价',
            type: 'inputNumber',
            prop: 'paBuyPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: true,
            precision: 2
          },
          {
            label: '原零售价',
            prop: 'retailPrice',
            align: 'center',
            width: '110',
            isShow: true
          },
          {
            label: '零售价',
            type: 'inputNumber',
            prop: 'paRetailPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: true,
            precision: 2
          },
          {
            label: '原最低零售价',
            prop: 'lowestPrice',
            align: 'center',
            width: '110',
            isShow: false
          },
          {
            label: '最低零售价',
            type: 'inputNumber',
            prop: 'paLowestPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: false,
            precision: 2
          },
          {
            label: '原会员价',
            prop: 'vipPrice',
            align: 'center',
            width: '110',
            isShow: false
          },
          {
            label: '会员价',
            type: 'inputNumber',
            prop: 'paVipPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: false,
            precision: 2,
            change: this.vipPriceChange
          },
          {
            label: '原批发价',
            prop: 'tradePrice',
            align: 'center',
            width: '110',
            isShow: false
          },
          {
            label: '批发价',
            type: 'inputNumber',
            prop: 'paTradePrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: false,
            precision: 2
          },
          {
            label: '原配送价',
            prop: 'deliveryPrice',
            align: 'center',
            width: '110',
            isShow: false
          },
          {
            label: '配送价',
            type: 'inputNumber',
            prop: 'paDeliveryPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: false,
            precision: 2
          },
          {
            label: '原PLUS价',
            prop: 'plusVipPrice',
            align: 'center',
            width: '110',
            isShow: false
          },
          {
            label: 'PLUS会员价',
            type: 'inputNumber',
            prop: 'paPlusVipPrice',
            align: 'center',
            width: '110',
            max: 99999.99,
            isShow: false,
            precision: 2
          },
          {
            label: '备注',
            type: 'input',
            maxLength: 16,
            prop: 'remarks',
            width: '200'
          },

        ],
        url: api.archives.priceDadjap
      },
      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '190',
            align: 'center'
          },
          {
            label: '品名',
            prop: 'goodsName',
            width: '140',
            align: 'center'
          },
          {
            label: '自编码',
            prop: 'artNo',
            width: '100',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '100',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '100',
            align: 'center'
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '100',
            align: 'center'
          },
          {
            label: '最低零售价',
            prop: 'lowestPrice',
            width: '120',
            align: 'center'
          },
          {
            label: '会员价',
            prop: 'vipPrice',
            width: '100',
            align: 'center'
          },
          {
            label: 'Plus会员价',
            prop: 'plusVipPrice',
            width: '120',
            align: 'center'
          },
          {
            label: '批发价',
            prop: 'tradePrice',
            width: '100',
            align: 'center'
          },
          {
            label: '配送价',
            prop: 'deliveryPrice',
            width: '100',
            align: 'center'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '100',
            align: 'center'
          }
        ],
        url: api.archives.goodsInfoIncludeSpecs
      },
      checkIndex: '',
      supplierInfo: {},
      flag: false,
      storeId: '',
      form: {}
    }
  },

  created() {
    // 一进页面未加任何操作多选框内容，需要得到传递
    let column = {
      label: '调价类别：',
      type: 'checkbox',
      prop: 'typesCheckbox',
      span: 24,
      data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.type'),
      change: this.priceTypeChange,
      defaultIndex: [0, 1]
    }
    this.$nextTick(() => {
      this.$refs.listOperationForm.checkBoxChange(column);
    });
    // this.setRelateStoreId(this.listFormOptions.columns);
  },
  mounted() {
    this.storeId = JSON.parse(localStorage.getItem('SYSUSER')).storeId
    if (this.storeId) { // 门店
      this.tips = ''
      this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = false;
      this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
      this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].hidden = true;
      this.getSelectParam({storeId: this.storeId})
    } else { // 商户
      this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = true;
      this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].hidden = false;
      this.tips = ''
      // this.loginTypeChange({relateType:10})
    }
    this.title = document.title + (this.$route.query.id ? '编辑' : '新增');
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  methods: {
    //点击 高级搜索显示
    complexFunc() {
      if (!this.isCheck) {
        this.complexShow = !this.complexShow;
      }
    },
    search() {
      if (this.goodsTxt === '' || this.goodsTxt === null) return;
      this.otherParam.otherName = this.goodsTxt;
      this.otherParam = {...this.otherParam, ...this.supplierInfo};
      this.isCheck = true;
      this.$axios
        .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
        .then(res => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              let tableData = res.data;
              if (tableData.length === 1) {
                let row = tableData[0];
                let tableList = this.$refs["listOperation"].getTabelData();
                let flag = true;
                if (tableList.length > 0) {
                  tableList.forEach(item => {
                    if (flag) {
                      if (item.barCode === row.barCode) flag = false;
                    }
                  });
                }
                if (!flag) {
                  this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                  return;
                }
                row.paBuyPrice = row.buyPrice// 进货价
                row.paRetailPrice = row.retailPrice;// 零售价
                row.paLowestPrice = row.lowestPrice// 最低零售价
                row.paVipPrice = row.vipPrice;// 会员价
                row.paTradePrice = row.tradePrice// 批发价
                row.paDeliveryPrice = row.deliveryPrice;// 配送价
                row.paPlusVipPrice = row.plusVipPrice;// plus会员价
                row.remarks = null;
                // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                this.$refs["listOperation"].setColumnData(row, tableList.length);
                this.currentTableList = this.$refs["listOperation"].getTabelData();
                this.$message.success("商品添加成功");
              } else {
                this.checkGoods();
              }
            } else {
              this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
            }
          } else {
            this.$message({type: "error", message: res.msg});
          }
        })
        .catch(err => {
        }).finally(() => {
        this.clearQueryParam();
        this.isCheck = false;
      });
    },
    clearQueryParam() {
      this.goodsTxt = '';
      this.otherParam.otherName = '';
    },
    // 条码回车检索
    getSearchInfo(rowData, index) {
      if (rowData.barCode) {
        // 通过货号获取商品信息
        this.queryGoodsByBarCode(rowData.barCode, index);
      } else {
        this.goodListSelect = false;
        this.listShow = true;
        this.checkIndex = index;
        this.$nextTick(() => {
          this.otherParam = {...this.otherParam, ...this.supplierInfo};
        })
      }
    },
    // 失焦 获取某行数据填充
    getInfo(rowData, index) {
      if (rowData.barCode) {
        // 通过货号获取商品信息
        this.queryGoodsByBarCode(rowData.barCode, index);
      }
    },
    // 关闭弹框
    // closeDialog(){
    //   this.listShow = false
    //   this.$refs.goodList.searchClear()
    // },
    // 详情
    getDetail(id) {
      this.loading = true;
      this.$axios
        .fetchGet(api.archives.priceDadjap + '?id=' + id, {})
        .then(data => {
          this.loading = false;
          if (data.code === 200 && data.data) {
            this.formModel = data.data;
            if (this.formModel.reviewerStatus === 10) {
              this.listFormOptions.disabled = true;
              this.listColumns.disabled = true;
              this.buttonShow = true;
              this.auditShow = true;
            } else {
              this.listFormOptions.disabled = false;
              this.listColumns.disabled = false;
              this.buttonShow = false;
              this.auditShow = false;
            }
            // //为头部表单赋值
            // if (data.data.relateType === 10) {//调价级别 商户
            //   this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = true;
            //   // this.listFormOptions.columns.filter(item => item.prop === 'seStoreId')[0].hidden = true;
            // } else {//调价级别 门店

            // }
            this.$nextTick(() => {
              if (!this.storeId) { // 如果是商户身份
                this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].hidden = false
                this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = true;
              } else { // 如果是门店身份
                this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].hidden = true;
                this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = false;
                this.$refs.listOperationForm.formModel.storeId = data.data.storeId;
                this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
              }
              // this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].hidden = true;
              // this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].hidden = false;
              // this.loginTypeChange({relateType:data.data.relateType})
              // this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0].disabled = true;
              // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
              // form赋值
              this.$refs.listOperationForm.setFormModel(data.data);
              // 为表格赋值
              this.$refs['listOperation'].addMoreRow(data.data.adjustmentGoodsMapList, 0);
            });
            this.priceTypeChange({types: data.data.types});
          } else if (data.code === 200 && !data.data) {
            this.$message({message: '获取数据出错！', type: 'error'});
            this.$router.push({path: '/warehouse/inventory/goods'});
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
    },
    // 选择门店类型
    storeTypeChange(form) {
      let storeId = this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0];// 指定门店
      if (form.openStore == 1) { // 全部门店
        storeId.hidden = true;
      } else { // 指定门店
        storeId.hidden = false;
        storeId.data = [];
        this.$axios.fetchPost(api.system.seStore + '/list', {}).then(data => {
          if (data.code === 200) {
            this.$refs.listOperationForm.formModel.storeId = '';
            storeId.data = data.data;
            let user = this.$utils.getSysUser();
            this.$refs.listOperationForm.formModel.storeId = user.storeId;
          }
        })
      }
    },
    // 选择调价级别
    // loginTypeChange(form) {
    //   this.form = form
    //   // let relateType = this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0];//调价级别
    //   let seStoreIds = this.listFormOptions.columns.filter(item => item.prop === 'seStoreIds')[0];//指定门店
    //   let storeId = this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0];//门店身份 显示自己门店
    //   if(this.storeId){//门店身份登录
    //     // seStoreIds.disabled = true
    //     // relateType.disabled = true
    //     seStoreIds.hidden = true;
    //     storeId.hidden = false
    //     storeId.disabled = true
    //   }else{//商户身份登录
    //     seStoreIds.disabled = false
    //     // relateType.disabled = false
    //     seStoreIds.hidden = false;
    //     storeId.hidden = true
    //     this.otherParam.storeId = -1
    //     // if (form.relateType === 10) {//商户
    //     //   this.otherParam.seStoreIds = null;
    //     //   seStoreIds.hidden = true;
    //     //   seStoreIds.tips = '';
    //     //   if(this.$refs.listOperationForm){
    //     //     this.$refs.listOperationForm.formModel.seStoreIds = null
    //     //   }
    //     // }else{//门店
    //     //   seStoreIds.hidden = false;
    //     //   seStoreIds.tips = '不选门店则默认为全部门店';
    //     // }
    //   }
    // },
    // 选择调价门店
    getSelectParam(param) {
      if (this.storeId) { // 如果是门店身份，传自己的id
        param.storeId = this.storeId;
        this.otherParam.storeId = param.storeId
      }
    },
    checkGoods() {
      this.listShow = true;
      this.goodListSelect = true;
      this.listTableData = this.$refs["listOperation"].getTabelData(); // table数据  原始的
      this.$nextTick(() => {
        this.otherParam = {...this.otherParam, ...this.supplierInfo};
        if (!this.storeId) { // 如果是商户身份
          this.otherParam.storeId = -1
        }
      })
    },
    // 确定 选中商品
    rowsSelectSubmit(rows) {
      rows.map(item => {
        item.paBuyPrice = item.buyPrice// 进货价
        item.paRetailPrice = item.retailPrice;// 零售价
        item.paLowestPrice = item.lowestPrice// 最低零售价
        item.paVipPrice = item.vipPrice;// 会员价
        item.paTradePrice = item.tradePrice// 批发价
        item.paDeliveryPrice = item.deliveryPrice;// 配送价
        item.paPlusVipPrice = item.plusVipPrice;// plus会员价
      });
      this.listShow = false;
      // this.$refs['listOperation'].addMoreRow(rows, 0);
      let tableList = this.$refs['listOperation'].getTabelData();
      this.$refs['listOperation'].addMoreRow(rows, tableList.length);
      if (rows && rows.length > 0) {
        this.$message.success("商品添加成功");
      }
    },

    // 选择某行数据
    rowCheck(row) {
      row.paBuyPrice = row.buyPrice// 进货价
      row.paRetailPrice = row.retailPrice;// 零售价
      row.paLowestPrice = row.lowestPrice// 最低零售价
      row.paVipPrice = row.vipPrice;// 会员价
      row.paTradePrice = row.tradePrice// 批发价
      row.paDeliveryPrice = row.deliveryPrice;// 配送价
      row.paPlusVipPrice = row.plusVipPrice;// plus会员价
      this.listShow = false;
      this.$refs['listOperation'].setColumnData(row, this.checkIndex);
    },
    validePirce(val) {
      const priceArray = ['paBuyPrice', 'paRetailPrice', 'paLowestPrice', 'paVipPrice',
        'paTradePrice', 'paDeliveryPrice', 'paPlusVipPrice'];
      if (priceArray.includes(val)) {
        return true
      } else {
        return false
      }
    },
    // 提交数据
    submitAuth() {
      if (!this.isCheck) {
        let param = this.getParams();
        // if (param.relateType === 20) {
        //   // if (!param.storeId) {
        //   //   this.$message({message: '调价级别为门店时,必须选择门店进行调价', type: 'info'});
        //   //   return;
        //   // }
        // }else{
        //   param.storeId = null
        // }
        let flag = false
        let testSave = false
        param.typesCheckbox.forEach(v => {
          param.adjustmentGoodsMapList.forEach(item => {
            if ((v.indexOf('进货价') != -1 && item.paBuyPrice == 0) ||
              (v.indexOf('零售价') != -1 && item.paRetailPrice == 0) ||
              (v.indexOf('最低零售价') != -1 && item.paLowestPrice == 0) ||
              (v.indexOf('PLUS会员价') != -1 && item.paPlusVipPrice == 0) ||
              (v.indexOf('会员价') != -1 && item.paVipPrice == 0) ||
              (v.indexOf('批发价') != -1 && item.paTradePrice == 0) ||
              (v.indexOf('配送价') != -1 && item.paDeliveryPrice == 0)
            ) {
              flag = true
            }
          })
        })
        if (!this.storeId && (!param.seStoreIds || param.seStoreIds.length === 0)) {
          this.$message({message: '请选择调价门店！', type: 'warning'});
        } else if (param.adjustmentGoodsMapList.length == 0) {
          this.$message({message: '商品信息无效！', type: 'warning'});
        } else {
          let priceFlag = false
          param.adjustmentGoodsMapList.map(item => {
            console.log('item=>', item);
            for (let key in item) {
              if (this.validePirce(key)) {
                if (item[key] > 99999.99) {
                  priceFlag = true
                }
              }
            }
          })
          if (priceFlag) return this.$message.warning('价格不能超过99999.99')
          testSave = param.adjustmentGoodsMapList.every(v => {
            if (v.goodsName) {
              return true
            } else {
              return false
            }
          })
          if (testSave) {
            if (flag) {
              this.$confirm('存在调价为0的商品？确认')
                .then(_ => {
                  this.save(param)
                }).catch(_ => {
              });
            } else {
              this.save(param)
            }
          }
        }
      }
    },
    save(param) {
      this.$confirm('是否确认保存?', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios
          .fetchPost(api.archives.priceDadjap, param)
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.auditShow = false;
              this.buttonShow = false;
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
              // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
              this.$refs.listOperationForm.setFormModel(data.data);
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '商品调价操作成功', type: 'success'});
              // if(data.data && data.data.id){
              //   this.getDetail(data.data.id)
              // }
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        }).finally(() => {
          loading.close()
        })
      }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
    },
    // 审核
    audit() {
      if (!this.isCheck) {
        this.$confirm('是否确认审核?', '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          let param = this.$utils.deepClone(this.getParams())
          // if (param.relateType === 20) {
          //   if (!param.storeId) {
          //     this.$message({message: '调价级别为门店时,必须选择门店进行调价', type: 'info'});
          //     return;
          //   }
          // }
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)'
          });
          this.$axios
            .fetchPost(api.archives.priceDadjap + '/audit', param)
            .then(data => {
              this.loading = false;
              if (data.code == 200) {
                this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
                // this.listFormOptions.columns.filter(item => item.prop === 'relateType')[0].disabled = true;
                this.auditShow = true;
                this.buttonShow = true;
                this.$refs.listOperationForm.setFormModel(data.data);
                // this.$message({message: '审核成功', type: 'success'});
                this.$notify({
                  type: "success",
                  title: '审核操作',
                  message: '成功',
                  showClose: false,
                });
                this.$router.push({path: '/archives/price/dadjap'});
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            }).catch(err => {
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          }).finally(() => {
            loading.close()
          })
        }).catch(() => this.$message({message: '审核取消！', type: 'info'}));
      }
    },
    getParams() {
      let tableList = this.$refs['listOperation'].getTabelData();
      let orderNumber = 1;
      tableList.map(item => {
        item.orderNumber = orderNumber++;
        if (item.goodsId == null) {
          item.goodsId = item.id;
        }
      });
      let totalParam = this.$refs['listOperation'].getSumData();
      let headParam = this.$refs.listOperationForm.getFormModel();
      totalParam.orderPrice = totalParam.cleanPrice;
      console.log(totalParam)

      return {
        ...{adjustmentGoodsMapList: tableList}, ...totalParam, ...headParam
      }
    },

    // 返回按钮事件
    beBack() {
      if (!this.isCheck) {
        this.$router.go(-1);
      }
    },
    refresh() {
      if (!this.isCheck) {
        this.$router.go(0);
      }
    },
    // 修改 调价类别
    priceTypeChange(formModel) {
      let types = [];
      formModel.types.map(type => {
        types.push(parseInt(type));
      });
      formModel.types = types;
      let paBuyPrice, paRetailPrice, paLowestPrice, paVipPrice, paPlusVipPrice, paTradePrice, paDeliveryPrice,
        buyPrice,
        retailPrice,
        lowestPrice, vipPrice, plusVipPrice, tradePrice, deliveryPrice = {};
      this.listColumns.columns.forEach(item => {
        if (item.prop === 'paBuyPrice') {
          paBuyPrice = item;
          paBuyPrice.isShow = false;
        }
        if (item.prop === 'paRetailPrice') {
          paRetailPrice = item;
          paRetailPrice.isShow = false;
        }
        if (item.prop === 'paLowestPrice') {
          paLowestPrice = item;
          paLowestPrice.isShow = false;
        }
        if (item.prop === 'paVipPrice') {
          paVipPrice = item;
          paVipPrice.isShow = false;
        }
        if (item.prop === 'paPlusVipPrice') {
          paPlusVipPrice = item;
          paPlusVipPrice.isShow = false;
        }
        if (item.prop === 'paTradePrice') {
          paTradePrice = item;
          paTradePrice.isShow = false;
        }
        if (item.prop === 'paDeliveryPrice') {
          paDeliveryPrice = item;
          paDeliveryPrice.isShow = false;
        }
        if (item.prop === 'buyPrice') {
          buyPrice = item;
          buyPrice.isShow = false
        }
        if (item.prop === 'retailPrice') {
          retailPrice = item;
          retailPrice.isShow = false;
        }
        if (item.prop === 'lowestPrice') {
          lowestPrice = item;
          lowestPrice.isShow = false;
        }
        if (item.prop === 'vipPrice') {
          vipPrice = item;
          vipPrice.isShow = false;
        }
        if (item.prop === 'tradePrice') {
          tradePrice = item;
          tradePrice.isShow = false;
        }
        if (item.prop === 'deliveryPrice') {
          deliveryPrice = item;
          deliveryPrice.isShow = false;
        }
        if (item.prop === 'plusVipPrice') {
          plusVipPrice = item;
          plusVipPrice.isShow = false;
        }
      });
      let priceType = formModel.types;
      priceType.map(type => {
          if (type === 40) {
            paVipPrice.isShow = true;
            vipPrice.isShow = true;
          } else if (type === 30) {
            paLowestPrice.isShow = true;
            lowestPrice.isShow = true;
          } else if (type === 50) {
            paTradePrice.isShow = true;
            tradePrice.isShow = true
          } else if (type === 60) {
            paDeliveryPrice.isShow = true;
            deliveryPrice.isShow = true
          } else if (type === 10) {
            paBuyPrice.isShow = true;
            buyPrice.isShow = true;
          } else if (type === 20) {
            paRetailPrice.isShow = true;
            retailPrice.isShow = true;
          } else if (type === 70) {
            paPlusVipPrice.isShow = true;
            plusVipPrice.isShow = true;
          }
        }
      );
    },
    vipPriceChange(form) {
      if (form.paRetailPrice > 0) {
        if (form.paRetailPrice - form.paVipPrice < 0) {
          this.$confirm('会员价不能大于零售价', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            form.paVipPrice = form.paRetailPrice;
          })
            .catch(() => {
              form.paVipPrice = form.paRetailPrice;
            })
        }
      } else {
        if (form.retailPrice - form.paVipPrice < 0) {
          this.$confirm('会员价不能大于零售价', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            form.paVipPrice = form.retailPrice;
          })
            .catch(() => {
              form.paVipPrice = form.retailPrice;
            })
        }
      }
    },
    priceDownloadTemplate() {
      this.$axios.fetchPost(api.archives.priceDownloadTemplate, {}).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$message({message: '导出异常', type: 'error'});
        }
      })
    },
    // 导入
    priceImport() {
      if (!this.isCheck) {
        this.importShow = true;
      }
    },
    exportErrorData(data) {
      const elink = document.createElement('a');
      elink.href = data;
      elink.click();
      this.loadingExt = false;
      this.$notify({
        type: "success",
        title: '错误商品导出操作',
        message: '成功',
        showClose: false,
      });
      // this.$message({message: '错误商品导出成功', type: 'success'});
    },
    importFile() {
      console.log('importFile');
      this.$confirm('只能上传.xls/.xlsx文件')
        .then(_ => {
          this.$utils.uploadFile((file) => {
            let formData = new FormData();
            formData.append('multipartFile', file);
            this.$nextTick(() => {
              this.$refs['importTemplate'].currentStep = 1;
            });
            this.$axios
              .fetchPostGoodsExport(api.archives.priceImport, formData)
              .then(data => {
                this.$nextTick(() => {
                  this.$refs['importTemplate'].currentStep = 2;
                })
                if (data.code === 200) {
                  this.importShow = false;
                  if (data.data) {
                    this.$nextTick(() => {

                      // 为头部表单赋值
                      // data.data.relateType = this.form.relateType
                      if (this.storeId) {
                        data.data.storeId = this.storeId// 门店 id
                      } else {
                        data.data.seStoreIds = this.$refs.listOperationForm.getFormModel().seStoreIds// 指定门店
                      }
                      this.$refs.listOperationForm.setFormModel(data.data);
                      // this.$refs.listOperationForm.formModel.seStoreIds = this.$refs.listOperationForm.getFormModel().seStoreIds
                      // 为表格赋值
                      data.data.adjustmentGoodsMapList.map((item, index) => {
                        item.id = item.goodsId;
                      });
                      this.$refs['listOperation'].addMoreRow(data.data.adjustmentGoodsMapList, 0);
                    });
                    this.priceTypeChange({types: data.data.types});
                    if (data.data.errorDataUrl) {
                      this.exportErrorData(data.data.errorDataUrl);
                    }
                  }
                } else {
                  this.$nextTick(() => {
                    if (data.errorMsg) {
                      this.$refs['importTemplate'].exportMessage = data.errorMsg;
                    }
                    this.$refs['importTemplate'].currentStep = 3;
                  })
                }
              })
              .catch((err) => {
              }).finally(() => {
            })
          })
        }).catch(() => {
        this.$refs['importTemplate'].currentStep = 0;
      });
    },
    downTemplate() {
      console.log('downTemplate');
      const loading = this.$loading({
        lock: true,
        text: '正在导出，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      this.$axios.fetchPost(api.archives.priceDownloadTemplate, {}).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$message({message: '导出异常', type: 'error'});
        }
      }).finally(() => {
        loading.close();
      })
    },
  }
}
</script>
<style scoped>
  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }

  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/price/DadjapAdd.vue